<template>
  <v-text-field
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    prefix="$"
    type="number"
    :label="label"
    :value="valueFormatted"
    :rules="appliedRules"
    hide-spin-buttons
    @change="changeHandler"
  />
</template>

<script>
export default {
  name: 'AdminFieldMoney',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: 'Edit',
    },
    fieldName: {
      type: String,
      require: true,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {
    changeHandler(newValue) {
      let timesAHundred = newValue * 100
      this.$emit('price', timesAHundred)
    }, // changeHandler
  },
  computed: {
    appliedRules() {
      let rules = this.rules || []
      if (!this.allowNegative) {
        rules.push(
          (v) => Number(v) >= Number(0) || `Enter a number greater than 0`
        )
      }
      return rules
    }, // appliedRules
    valueFormatted() {
      return (Number(this.value) / 100).toFixed(2)
    }, // valueFormatted
  },
}
</script>
